/**
 * Item de menu (com nome) cujo FullPath é o da página. Procura também nos submenus: antes só olhava o 1º nível, então uma entrada dentro de
 * um grupo (ex.: "Grid's Exemplo" → entradas) mostrava o nome do Subject na aba em vez do nome do menu.
 */
export function findMenuItem (options, fullPath) {
  for (const option of options || []) {
    if (option.FullPath === fullPath && option.Name) return option

    const nested = findMenuItem(option.Menus, fullPath)
    if (nested) return nested
  }

  return undefined
}

/** Nome do item de menu da página (ver findMenuItem). */
export function findMenuName (options, fullPath) {
  return findMenuItem(options, fullPath)?.Name
}
